import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../auth.service';
import { UserService } from '../../user/user.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  private isBrowser: boolean;

  constructor(
    private oauthService: OAuthService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      this.configure();
      this.subscribeToOAuthEvents();
    }
  }

  private configure() {
    const authConfig: AuthConfig = {
      issuer: 'https://accounts.google.com',
      redirectUri: window.location.origin + '/login',
      //clientId: '681768742669-2ue1oeniv7et07n4fmn47e8ctqt0ci8f.apps.googleusercontent.com',
      clientId:
        '665737795990-ovf7ofmrer8uncs9mmkgg2i5aeo84bne.apps.googleusercontent.com',

      scope: 'openid profile email',
      responseType: 'token id_token',
      showDebugInformation: true,
      strictDiscoveryDocumentValidation: false,
    };

    this.oauthService.configure(authConfig);
    this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }

  private subscribeToOAuthEvents() {
    this.oauthService.events.subscribe((event) => {
      if (event.type === 'token_received') {
        const userData = {
          accessToken: this.token,
          email: this.identityClaims.email,
          name: this.identityClaims.name,
          picture: this.identityClaims.picture, // ✅ دي الصورة من Google Claims
          sub: this.identityClaims.sub,
          nickname: this.identityClaims.given_name,
        };

        this.authService.loginWithGoogle(userData).subscribe((user: any) => {
          user.picture = user.picture || this.identityClaims.picture;

          this.userService.setTokenInfo(
            user.accessToken,
            user.refreshToken,
            user.userId,
            user.role
          );
          this.userService.getUserData().subscribe({
            next: (response: any) => {
              this.userService.setUserInfo({
                ...response,
                picture: response.pictureUrl || this.identityClaims.picture,
              });
            },
          });
          // this.userService.setUserInfo(user);

          // ✅ بعد اللوجين نرجع المستخدم للصفحة اللي كان عايزها
          const redirectUrl = localStorage.getItem('redirectUrl') || '/';
          localStorage.removeItem('redirectUrl');
          this.router.navigate([redirectUrl]);
        });
      }
    });
  }

  public login(): void {
    if (this.isBrowser) {
      this.oauthService.initLoginFlow();
    }
  }

  public logout(): void {
    if (this.isBrowser) {
      this.oauthService.logOut();
    }
  }

  public get identityClaims(): any {
    return this.oauthService.getIdentityClaims();
  }

  public get token(): string {
    return this.oauthService.getAccessToken();
  }

  public get isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }
}
